// extracted by mini-css-extract-plugin
export default {"body":"wallet_body__BiCX4","tabContainer":"wallet_tabContainer__MH3IX","listContainer":"wallet_listContainer__n9-6O"};